export default "__VITE_ASSET__75851017__"